import { createContext, useContext } from "react";
import { IDIOMA_FUENTE } from "../constants/propiedadIdiomas";

const PropiedadIdiomaContext = createContext({
  idiomaVista: IDIOMA_FUENTE,
  setIdiomaVista: () => {},
  labelsMap: {},
  soloLecturaIdioma: false,
  t: (_, fb) => fb,
  tv: (x) => x,
});

export function PropiedadIdiomaProvider({ value, children }) {
  return (
    <PropiedadIdiomaContext.Provider value={value}>
      {children}
    </PropiedadIdiomaContext.Provider>
  );
}

/** Traduce label de campo: t('web_titulo', 'Título del inmueble') */
export function usePropiedadLabel() {
  const { t } = usePropiedadIdioma();
  return t || ((_, fb) => fb);
}

export function usePropiedadIdioma() {
  return useContext(PropiedadIdiomaContext);
}

export default PropiedadIdiomaContext;
